import { render, staticRenderFns } from "./SocialWallComposer.vue?vue&type=template&id=392071eb&scoped=true"
import script from "./SocialWallComposer.vue?vue&type=script&lang=js"
export * from "./SocialWallComposer.vue?vue&type=script&lang=js"
import style0 from "./SocialWallComposer.vue?vue&type=style&index=0&id=392071eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392071eb",
  null
  
)

export default component.exports